class pdpSwiper extends HTMLElement {
  constructor() {
    super();
    this.options = this.getAttribute('data-swiper') ? JSON.parse(this.getAttribute('data-swiper')) : {};
    this.swiper;
  }

  connectedCallback() {
    this.initGallerySlider();
    this.zoomTrigger();
    this.setSwiperImagesAlt();

    subscribe(PUB_SUB_EVENTS.variantChange, async (payload) => {
      this.setSwiperImagesAlt();
    });
  }

  static get observedAttributes() {
    return [
      'data-reset'
    ];
  }

  /**
   * Get the thumbnails in the swiper and set: 
   */
  setSwiperImagesAlt() {
    const thumbnailsSlider = this.querySelectorAll('.swiper-pagination-thumbnail');
    const mainSlides = this.querySelectorAll('.product-media-container .product__media.media');

    this.assignVariantAltAndTitle(thumbnailsSlider);
    this.assignVariantAltAndTitle(mainSlides);
  }


  assignVariantAltAndTitle(sliderSlides){
    sliderSlides.forEach((slide, index) => {
      let slideImg = slide.querySelector('img');
      const slideAlt = slideImg.getAttribute('alt');
      const newSeoValue = `${slideAlt} - Image ${index + 1} - Variant Link`;
      slide.querySelector('img').setAttribute('alt', newSeoValue)
      slide.querySelector('img').setAttribute('title', newSeoValue)
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    //console.log(`Attribute ${name} has changed from ${oldValue} to ${newValue}.`);
    if (oldValue == "false") {
      this.updateGallery();
      this.setAttribute('data-reset', "false");
    }
  }

  initGallerySlider() {
    const self = this;

    if (typeof Swiper !== 'undefined') {
      let galleryWrapper = this.querySelector('.swiper.gallery-swiper');
      this.swiper = new Swiper(galleryWrapper, self.options);


      this.swiper.on('init', function () {
        self.updateAriaHidden(this);
      });

      this.swiper.on('slideChange', function () {
        self.updateAriaHidden(this);
      });

      this.paginationThumbnail();

      this.removeSkeletonLoader();
    }
  }
  updateGallery() {
    this.swiper.destroy(true, true);
    this.initGallerySlider();
  }

  updateAriaHidden(swiper) {
    swiper.slides.forEach((slide, index) => {
      const isActiveSlide = index === swiper.activeIndex;
      slide.setAttribute('aria-hidden', isActiveSlide ? 'false' : 'true');

      const interactiveElements = slide.querySelectorAll('button, [tabindex]');
      interactiveElements.forEach(el => {
        el.setAttribute('tabindex', isActiveSlide ? '0' : '-1');
      });
    });
  }

  // Nella pagination di default di Swiper, vengono inserite delle immagini in modo da creare delle thumbnails
  paginationThumbnail() {
    let pagBullets = this.querySelectorAll('.swiper-pagination-thumbnail');
    pagBullets.forEach((bullet, index) => {
      let imgCloned = this.swiper.slides[index].querySelector('.product__modal-opener .product__media').cloneNode(true);
      if (imgCloned) {
        bullet.appendChild(imgCloned);
      }
    });
  }

  zoomTrigger() {
    const self = this;
    let zoomTrigger = this.querySelector('.zoom-trigger');
    zoomTrigger.addEventListener('click', function () {
      let slideToZoom = self.querySelector('.swiper-slide-active .product__media-toggle');
      if (slideToZoom) {
        slideToZoom.click();
      }
    });
  }

  removeSkeletonLoader() {
    let swiperPaginationLoader = this.querySelectorAll('.swiper-pagination--custom-loader');
    swiperPaginationLoader.forEach(paginationLoader => {
      paginationLoader.style.display = 'none';
    });
    let swiperPagination = this.querySelectorAll('.swiper-pagination--custom');
    swiperPagination.forEach(pagination => {
      pagination.style.display = 'flex';
    });
  }
}

customElements.define('pdp-swiper', pdpSwiper);